export default "__VITE_ASSET__w4pWXl5H__"